export default __webpack_public_path__ + "media/images/home/slide_spring_2026_sm-b56060bba1638e1fa79700e2dd45f0e2.png";